var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_7174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.9882V11.6934",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87891 16.2383L10.5018 18.8654L13.1246 16.2383",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1726 13.6168H14.9595C15.4945 13.6177 16.0221 13.4927 16.4998 13.252C16.9776 13.0112 17.3919 12.6614 17.7094 12.2309C18.027 11.8003 18.2387 11.3011 18.3276 10.7736C18.4165 10.2461 18.38 9.70506 18.2211 9.19425C18.0622 8.68344 17.7853 8.21719 17.4129 7.83318C17.0404 7.44917 16.5828 7.15818 16.0771 6.98374C15.5714 6.8093 15.0317 6.7563 14.5018 6.82903C13.9718 6.90175 13.4663 7.09816 13.0263 7.40238C12.8506 6.46722 12.4239 5.59745 11.7919 4.88619C11.1598 4.17494 10.3462 3.64899 9.4382 3.36467C8.53017 3.08035 7.5619 3.04835 6.63708 3.27212C5.71225 3.49589 4.86571 3.96699 4.18809 4.63497C3.51047 5.30295 3.0273 6.14266 2.79031 7.06419C2.55332 7.98571 2.57144 8.95434 2.84273 9.86636C3.11402 10.7784 3.62827 11.5994 4.3304 12.2416C5.03252 12.8838 5.8961 13.3229 6.82864 13.5119",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_7174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSvg);
export default __webpack_public_path__ + "static/media/downloadIconSVG.5e7e9abf03223478b645af4271d4eaeb.svg";
export { ForwardRef as ReactComponent };